import { Outlet } from 'react-router';
import { lazy, Suspense } from 'react';

import { usePathname } from 'src/routes/hooks';

import { roles } from 'src/utils/roles';

import { CONFIG } from 'src/config-global';
import { DashboardLayout } from 'src/layouts/dashboard';

import { LoadingScreen } from 'src/components/loading-screen';
import { PageTransition } from 'src/components/animate/page-transition';

import { AuthGuard, RoleBasedGuard } from 'src/auth/guard';

// ----------------------------------------------------------------------

// Pages
const AlignmentAssignmentViewPage = lazy(() => import('src/pages/misc/alignment-assignment/view'));

// ----------------------------------------------------------------------

const LayoutContent = () => {
  const pathname = usePathname();

  return (
    <DashboardLayout>
      <Suspense fallback={<LoadingScreen />} key={pathname}>
        <PageTransition>
          <Outlet />
        </PageTransition>
      </Suspense>
    </DashboardLayout>
  )
};

export const miscRoutes = [
  {
    path: 'misc',
    element: CONFIG.auth.skip ? <LayoutContent /> : <AuthGuard><LayoutContent /></AuthGuard>,
    children: [
      {
        path: 'alignment-assignment', children: [
          { element: <RoleBasedGuard roles={[roles.ORG_ADMIN]} children={<AlignmentAssignmentViewPage />} />, index: true },
        ]
      },
    ],
  },
];
